<template>
    <div>
        <el-container style="height: 100%">
            <el-header style="z-index: 11;">
                <div class="detail_title">
                    <div class="title-left">
                        <div class="row-1">
                        {{ papername }}<span v-if='user_score' class='score'>（ 得分：{{user_score || '-'}}分，总分：{{paper_score || '-'}} ）</span>
                        </div>
                    </div>
                    <div class="title-right">
                        <el-dropdown>
                        <span class="el-dropdown-link">
                        <span style="font-weight:700; font-size: 16px; cursor: pointer;">{{ name }}<i class="el-icon-arrow-down el-icon--right"></i></span>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="quitSystem()">
                                    退出登录
                                </span>
                            </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-header>
            <el-main>
                <div class="text_content" v-if='data'>
                    <!-- 材料 -->
                    <div v-if='type == 0'>
                        <p v-html='data.stem'></p>
                        <span class="enclosure" v-for='i in data.stem_appendant'>
                            <span @click='material_enclosure(i)' v-if='i.file_type == 0'><img src="./img/pic.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 1'><img src="./img/video.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 2'><img src="./img/audio.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                        </span>
                        <div v-for='(i,index) in data.material_content'>
                            <p class="material_science">材料{{index+1}}</p>
                            <p v-html='i.content'></p>
                            <span class="enclosure" v-for='item in i.appendant'>
                              <span @click='material_enclosure(item)' v-if='item.file_type == 0'><img src="./img/pic.png" alt=""></span>
                              <span @click='material_enclosure(item)' v-else-if='item.file_type == 1'><img src="./img/video.png" alt=""></span>
                              <span @click='material_enclosure(item)' v-else-if='item.file_type == 2'><img src="./img/audio.png" alt=""></span>
                              <span @click='material_enclosure(item)' v-else-if='item.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                            </span>
                        </div>
                        <!-- <p class="question_item">选项</p>
                        <p v-for='(i,index) in data.question_choices'><span class="ques_words">{{String.fromCharCode(index+65)}}</span>{{i.choice}}</p> -->
                    </div>
                    <!-- 思路点拨 -->
                    <div v-if='type == 1'>
                        <!-- 无层级 -->
                        <div v-if="data.step_level === 0" class="no-level-wrapper">
                          <p v-html='data.step_explain'></p>
                          <span class="enclosure" v-for='i in data.stepexplain_appendant' :key="i">
                            <span @click='material_enclosure(i)' v-if='i.file_type == 0'><img src="./img/pic.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 1'><img src="./img/video.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 2'><img src="./img/audio.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                          </span>
                        </div>
                        <!-- 有层级 -->
                        <div v-else-if="data.step_level === 1 && data.new_step_explain.length > 0" class="hasLevel-wrapper">
                          <div class="level1-outer" v-for="(item, i) in data.new_step_explain" :key="i">
                            <div class="level1-title"><span class="level-num">{{i + 1}}</span>{{item.title}}</div>
                            <div class="level1-content-wrapper">
                              <p v-html='item.content'></p>
                              <span class="enclosure" v-for='(oneAppend, j) in item.explain_append' :key="j">
                                <span @click='material_enclosure(oneAppend)' v-if='oneAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                              </span>
                            </div>
                            <div class="level2-wrapper" v-if="item.children.length > 0">
                              <div class="level2-outer" v-for="(child, k) in item.children" :key="k">
                                <div class="level2-title"><span class="level-num">{{i + 1}}.{{k + 1}}</span>{{child.title}}</div>
                                <div class="level2-content-wrapper">
                                  <p v-html='child.content'></p>
                                  <span class="enclosure" v-for='(childAppend, m) in child.explain_append' :key="m">
                                    <span @click='material_enclosure(childAppend)' v-if='childAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                    <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                    <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                    <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- 解析 -->
                    <div v-if='type == 2'>
                        <!-- 无层级 -->
                        <div v-if="data.explain_level === 0" class="no-level-wrapper">
                          <p v-html='data.explain_a'></p>
                          <span class="enclosure" v-for='i in data.explain_appendant' :key="i">
                            <span @click='material_enclosure(i)' v-if='i.file_type == 0'><img src="./img/pic.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 1'><img src="./img/video.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 2'><img src="./img/audio.png" alt=""></span>
                            <span @click='material_enclosure(i)' v-else-if='i.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                          </span>
                        </div>
                        <!-- 有层级 -->
                        <div v-else-if="data.explain_level === 1 && data.new_explain.length > 0" class="hasLevel-wrapper">
                          <div class="level1-outer" v-for="(item, i) in data.new_explain" :key="i">
                            <div class="level1-title"><span class="level-num">{{i + 1}}</span>{{item.title}}</div>
                            <div class="level1-content-wrapper">
                              <p v-html='item.content'></p>
                              <span class="enclosure" v-for='(oneAppend, j) in item.explain_append' :key="j">
                                <span @click='material_enclosure(oneAppend)' v-if='oneAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                              </span>
                            </div>
                            <div class="level2-wrapper" v-if="item.children.length > 0">
                              <div class="level2-outer" v-for="(child, k) in item.children" :key="k">
                                <div class="level2-title"><span class="level-num">{{i + 1}}.{{k + 1}}</span>{{child.title}}</div>
                                <div class="level2-content-wrapper">
                                  <p v-html='child.content'></p>
                                  <span class="enclosure" v-for='(childAppend, m) in child.explain_append' :key="m">
                                    <span @click='material_enclosure(childAppend)' v-if='childAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                    <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                    <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                    <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- 智能批改结果 -->
                    <div v-if='type == 3'>
                        作答分析
                        <div v-if='data.answer_evaluate'>
                            <p class="content_title">总体评价</p>
                            {{data.answer_evaluate}}
                        </div>
                        <p class="content_title">优点</p>
                        <div v-for='i in data.answer_merit'>
                            <p>{{i.part_name}}</p>
                            <p>{{i.list}}</p>
                        </div>
                        <p class="content_title">问题</p>
                        <div v-for='i in data.answer_defect'>
                            <p>{{i.part_name}}</p>
                            <p>{{i.list}}</p>
                        </div>
                        <p class="content_title">建议</p>
                        <div v-html='data.answer_advance'></div>
                        <div class="mar_top">
                            参考答案
                            <p v-html='data.question_correct_answer'></p>
                        </div>
                        <div v-if='data.question_explain'>
                            答案解析
                            <p v-html='data.question_explain'></p>
                        </div>
                    </div>
                    <!-- 评分标准 -->
                    <div v-if='type == 4'>
                        <p class="content_title">内容采分点1</p>
                        <div v-for='i in data.content_standard'>
                            <p class="content_score"><img src="../../../static/images/papertype.png" alt="">{{i.part_name}}</p>
                            <div v-for='item in i.part_info' class="content_section">
                                <p>采分点：{{item.score}}分</p>
                                <p>关键句：<span>{{item.keyline}}({{item.score}}分)</span></p>
                            </div>
                        </div>
                        <p class="content_title">结构采分点</p>
                        <div v-for='i in data.structure_standard'>
                            <p class="content_score"><img src="../../../static/images/papertype.png" alt="">{{i.part_name}}</p>
                            <div v-for='item in i.part_info'>
                                <p v-if="i.part_info">{{item.remind}}({{item.score}}分)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import VideoPlayer from '@/components/video-player'
    import global_ from "../../global/index"

    export default {
        data() {
          return {
            name: '',
            papername: window.localStorage.getItem('name'),
            user_score: window.localStorage.getItem('user_score'),
            paper_score: window.localStorage.getItem('paper_score'),
            data: null,
            type: this.$route.params.text_type
          };
        },
        mounted(){
          this.name = window.localStorage.getItem('user_no')
          this.getcontent()
        },
        methods:{
            getcontent(){
                this.$api.GETEXERCISEQUESTIONINFO({
                    object_id: this.$route.params.object_id,
                    record_id: this.$route.params.record_id,
                    appid: 'pigai',
                    user_id: this.$route.params.sso_id,
                    object_type: this.$route.params.object_type
                }).then((res) => {
                    if(res.retcode == 0){
                      // this.data = res.data[0]
                      for(let i=0;i<res.data.length;i++){
                          if(res.data[i].question_id == this.$route.params.question_id){
                              this.data = res.data[i]
                          }
                      }
                    }
                })
            },
            material_enclosure(item){
                if (item.file_type == 0 || item.file_type == 3) {
                    window.open(item.file_url)
                } else if (item.file_type == 1 || item.file_type == 2) {
                    let video_window = window.open('')
                    let href =  this.$router.resolve({
                        path: '/video-preview/' + item.media_id
                    })
                    video_window.location = href.href
                }
            }
        }
    }
</script>

<style lang="less">
    .text_content{
        margin: 0 40px;
    }
    .detail_title {
        margin: 0;
        height: 59px;
        border-bottom: 1px solid #e5e5e5;
        width: 100%;
        padding: 0 360px;
        box-sizing: border-box;
        position: fixed;
        top:0;
        left:0;
        background-color: #fff;
        z-index: 99;
        display: flex;
        .title-left {
            flex: 1 0 auto;
            height: 100%;
            .row-1 {
                height: 59px;
                line-height: 60px;
                font-weight: bolder;
            }
            .score {
                font-size: 14px;
                font-weight: normal;
            }
        }
        .title-right {
            flex: 0 0 auto;
            height: 100%;
            line-height: 60px;
            .el-dropdown{
                height: 59px;
                margin-left: 20px;
            }
        }
    }
    .content_title{
        position: relative;
        padding-left: 10px;
    }
    .content_title::before{
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 20px;
        border-radius: 2px;
        background-color: #6594fe;
    }
    .content_section{
        margin-bottom: 30px;
    }
    .choose_keyline{
        color: #6594fe;
    }
    .content_score{
        img{
            vertical-align: middle;
            margin-right: 10px;
        }
    }
    .enclosure{
        display: inline-block;
        width: 24px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        margin-right: 10px;
        border: 1px solid #e6e7e8;
        border-radius: 4px;
        cursor: pointer;
    }
    .mar_top{
        margin-top: 20px;
    }
.hasLevel-wrapper{
  border: 1px solid #ebebeb;
  border-radius: 3px;
  margin-right: 25px;
  box-sizing: border-box;
  .level1-outer{
    .level1-title{
      background: #fafafa;
      padding: 10px 15px;
      font-weight: bold;
      .level-num{
        display: inline-block;
        width: 26px;
        text-align: center;
        height: 26px;
        line-height: 26px;
        border-radius: 50%;
        background: #1890ff;
        color: #ffffff;
        margin-right: 5px;
      }
    }
    .level1-content-wrapper, .level2-content-wrapper{
      padding: 0 15px 15px 15px;
    }
    .level2-wrapper{
      .level2-title{
        background: #fafafa;
        padding: 10px 15px;
        font-weight: bold;
        .level-num{
          display: inline-block;
          width: 26px;
          text-align: center;
          height: 26px;
          line-height: 26px;
          border-radius: 50%;
          color: #1890ff;
          margin-right: 5px;
          border: 1px solid #1890ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homework-detail/index.vue